import { FormattedMessage } from 'react-intl'
import TextLink from 'LuxKit/TextLink'
import styled from 'styled-components'
import useDoublePointsCampaignTier from '../hooks/useDoublePointsCampaignTier'

const SubtitleContainer = styled.div`


  &.bronze {
    color: ${props => props.theme.palette.product.loyalty.bronze.normalContrast};
  }

  &.silver {
    color: ${props => props.theme.palette.product.loyalty.silver.normalContrast};
  }

  &.gold {
    color: ${props => props.theme.palette.product.loyalty.gold.normalContrast};
  }

  &.platinum {
    color: ${props => props.theme.palette.product.loyalty.platinum.normalContrast};
  }
`

function DoublePointTakeoverSubtitleContent() {
  const displayTier = useDoublePointsCampaignTier()
  return (
    <SubtitleContainer className={displayTier}>
      <FormattedMessage
        id="n2G2uAnlraSAuETDR8ts"
        defaultMessage="Double status credits on all hotels, tours and cruises! Limited time only. <link>View all offers</link>"
        
        values={{
          link: (chunks) => <TextLink wrap="no-wrap" to="/double-status-credits">{chunks}</TextLink>,
        }}
      />
    </SubtitleContainer>
  )
}

export default DoublePointTakeoverSubtitleContent
